export default __webpack_public_path__ + "static/media/YAS0340.34I-29791_-17233_0.79426cb7.jpg";